import { render, staticRenderFns } from "./CommentView.vue?vue&type=template&id=67f37412&"
import script from "./CommentView.vue?vue&type=script&lang=js&"
export * from "./CommentView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports